const contentContact = () => import('@/pages/content/contact/index.vue');

export default [{
    path: '/content/contact',
    component: contentContact,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '联系方式',
        activeRoute: '/content/contact'
    }]
}];